import React from 'react';
import { SubmitHandler } from 'react-hook-form';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import CheckListForm from '../../components/CheckListForm';
import { ICheckList } from '../../components/CheckListForm/schema';

interface IProps {
  onSubmit: SubmitHandler<ICheckList>;
}

const NewCheckListView: React.FC<IProps> = ({ onSubmit }) => (
  <Card>
    <CardHeader>
      <CardTitle>Novo Check List</CardTitle>
      <CardDescription>
        Crie um novo Check List para suas etiquetas.
      </CardDescription>
    </CardHeader>

    <CardContent className="p-4 space-y-4">
      <CheckListForm
        onSubmit={onSubmit}
        submitText="Criar Lista de Verificação"
      />
    </CardContent>
  </Card>
);

export default NewCheckListView;
